import { render, staticRenderFns } from "./registro_edicion_gestionpagare.vue?vue&type=template&id=dda406ec&scoped=true"
import script from "./registro_edicion_gestionpagare.vue?vue&type=script&lang=js"
export * from "./registro_edicion_gestionpagare.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_gestionpagare.vue?vue&type=style&index=0&id=dda406ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda406ec",
  null
  
)

export default component.exports